<template>
    <div>
    <button class="c-btn c-btn--secondary c-btn--tiny no-margin" @click="openModal(value)">Activeren</button>
    
    <c-confirm-modal
        v-show="modal"
        @action="activateProduct"
        @close="modal = false"
        title="Activeren"
        subtitle="Weet je zeker dat je deze vooraad wilt activeren?"
        button="Activeren">
    </c-confirm-modal>

</div>
</template>

<script>
import Column from '@mixins/Column';
import CConfirmModal from '@app/modals/ConfirmModal';

export default {
    mixins: [ Column ],
    components: {
        CConfirmModal
    },
    data() {
        return {
            modal: false,
        }
    },
    methods: {
        openModal() {
          this.modal = true;
		},
        activateProduct() {
            this.$xhr.post('/api/products/' + this.value + '/active').then( ({result}) => {
                this.$store.dispatch('toast/success', {title: 'Activeren', text: 'Product is geactiveerd'});
                this.modal = false;
                this.$store.dispatch('listener/emit', 'reload-products');
                this.$store.dispatch('listener/emit', 'reload-inactive-products');
			}).catch((e) => {
			});
        },
    }
}
</script>
